import React from 'react';
import { ReactComponent as CloseIcon } from '../../asset/svg/close-golden.svg';

import { ButtonElem } from '../../common/button';
import styled from 'styled-components';

export const Component: React.FC<{
  onClick: () => void;
  // disabled: any;
  errorMessage?: string;
  isLoading?: boolean;
  isError?: boolean;
  isIcon: boolean;
}> = ({ onClick, isIcon }) => {
  return (
    <>
      {isIcon ? (
        <CloseButton onClick={onClick}>
          <CloseIcon />
        </CloseButton>
      ) : (
        <ButtonElem
          // disabled={disabled}
          onClick={onClick}
          type="submit"
          tid="POPUP.BUTTON.VIEWED"
        />
      )}
    </>
  );
};

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    opacity: 0.7;
  }
`;
